;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import type { VisualCopy } from './types'

/** Dutch: the language the application itself is written in. */
export const NL: VisualCopy = {
  status: {
    klaar: 'Klaar ✓',
    loopt: 'Loopt',
    controle: 'Controle',
    ontvangen: 'Ontvangen',
    gepland: 'Gepland',
    leeg: '—',
  },
  workflow: {
    ontvangen: 'Administratie ontvangen',
    uitvoering: 'In uitvoering',
    controle: 'Gereed voor controle',
    afgerond: 'Afgerond',
  },
  period: {
    month: 'Juli 2026',
    monthLower: 'juli 2026',
    closingBookYear: 'Boekjaar 2025',
    currentBookYear: 'Boekjaar 2026',
    currentYear: '2026',
  },
  monthsShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
  monthsFull: [
    'Januari',
    'Februari',
    'Maart',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Augustus',
    'September',
    'Oktober',
    'November',
    'December',
  ],
  weekdaysShort: ['ma', 'di', 'wo', 'do', 'vr', 'za', 'zo'],
  weekdays: ['maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag', 'zondag'],
  yearActivity: {
    jaarrekening: { label: 'Jaarrekening', short: 'JR' },
    vpb: { label: 'VPB', short: 'VPB', fullLabel: 'Vennootschapsbelasting (VPB)' },
    kvk: { label: 'KvK', short: 'KvK', fullLabel: 'KvK-publicatie' },
    ib: { label: 'IB', short: 'IB', fullLabel: 'Inkomstenbelasting (IB)' },
  },
  monthActivity: {
    administratie: { label: 'Administratie', short: 'Adm.', fullLabel: 'Financiële administratie' },
    omzetbelasting: { label: 'Omzetbelasting', short: 'OB', fullLabel: 'Omzetbelastingaangifte' },
    salaris: { label: 'Salaris', short: 'Sal.', fullLabel: 'Salarisverwerking' },
    loonheffingen: { label: 'Loonheffingen', short: 'LH', fullLabel: 'Aangifte loonheffingen' },
  },
  teamRole: {
    accountant: 'Accountant',
    relatiebeheerder: 'Relatiebeheerder',
    assistentAccountant: 'Assistent-accountant',
    salarisadministrateur: 'Salarisadministrateur',
    administrateur: 'Administrateur',
  },
  contactRole: {
    directie: 'DIRECTIE',
    financieleAdministratie: 'FINANCIËLE ADMINISTRATIE',
    eigenaar: 'EIGENAAR',
  },
  word: {
    hours: 'uren',
    hoursUnit: 'uur',
    hoursWord: 'uur',
    tasks: 'taken',
    complete: 'voltooid',
    clients: 'Klanten',
    clientsLower: 'klanten',
    planned: 'gepland',
    of: 'van',
    client: 'Klant',
    activity: 'Activiteit',
    amount: 'Aantal',
    project: 'Project',
    description: 'Omschrijving',
    owner: 'Behandelaar',
    period: 'Periode',
    status: 'Status',
    name: 'Naam',
    address: 'Adres',
    contract: 'Contract',
    billable: 'Facturabel',
    checklist: 'Checklist',
    frequency: 'Frequentie',
    price: 'Prijs',
    thisMonth: 'deze maand',
    perDay: 'per dag',
    booked: 'geboekt',
    dayTotal: 'Dagtotaal',
    total: 'Totaal',
    search: 'Zoeken',
    days: 'dagen',
    completed: 'afgerond',
    at: 'om',
    budget: 'Budget',
    used: 'Verbruikt',
    workItem: 'Werkzaamheid',
    by: 'door',
    step: 'Stap',
    open: 'Open',
    results: 'resultaten',
    today: 'Vandaag',
    full: 'vol',
    room: 'ruimte',
    realised: 'Gerealiseerd',
  },
  screen: {
    aiChat: {
      assistant: 'AI-assistent',
      viaMcp: 'AI-assistent via MCP',
      askPlanning: 'Stel een vraag over de planning…',
      askHours: 'Stel een vraag over de uren…',
      assistantName: 'Offsoo-assistent',
    },
    budget: {
      title: 'Budgetten',
      caption: 'Budgetten per klant, met overschrijdingen',
      sortedByUse: 'Gesorteerd op verbruik',
      overBudget: (count) => `${count} boven budget`,
    },
    capacity: {
      title: 'Capaciteit',
      caption: 'Capaciteit per medewerker',
      perMonth: 'Per maand',
      perEmployee: 'Per medewerker',
      overload: 'Mei 124% — herverdeel',
    },
    clientDossier: {
      title: 'Klanten',
      caption: 'Klant toevoegen via KvK',
      addClient: 'Klant toevoegen',
      addClientPlus: '+ Klant toevoegen',
      addViaKvk: 'Klant toevoegen via KvK',
      kvkNumber: 'KvK-nummer',
      legalForm: 'Rechtsvorm',
      fromKvk: 'Uit de KvK ✓',
      headOffice: 'Hoofdvestiging',
      kvkIntegration: 'KvK-integratie',
      allClients: 'Alle klanten',
      add: 'Toevoegen',
      added: 'Toegevoegd ✓',
    },
    clientList: {
      caption: 'Het klantenbestand doorzocht en een groep uitgeklapt',
      ofResults: (total) => `van de ${total} resultaten`,
    },
    dossierTabs: {
      caption: (client: string) => `Het dossier van ${client}: gegevens, planning, uren en taken`,
      tabOverview: 'Overzicht',
      tabPlanning: 'Planning',
      tabHours: 'Uren',
      tabTasks: 'Taken',
      tabLog: 'Logboek',
      generalInfo: 'Algemene informatie',
      contactPeople: 'Contactpersonen',
      accountManagerCard: 'Relatiebeheerder',
      addressCard: 'Adresgegevens',
      monthPlanning: 'Maandplanning',
      yearPlanning: 'Jaarplanning',
      hoursCard: 'Uren en budget',
      perMemberCard: 'Uren per medewerker',
      openTasks: 'Openstaand werk',
      hoursLabel: 'Uren',
      billable: 'Facturabel',
      nonBillable: 'Niet facturabel',
      leftOfBudget: 'Over budget',
      ofBudget: 'van het budget',
      perYear: 'per jaar',
      agreed: 'VASTGELEGD',
      subtasks: (done: number, total: number) => `${done} van de ${total} subtaken`,
    },
    clientRecord: {
      caption: (client) => `Klantdossier van ${client}`,
      general: 'ALGEMENE INFORMATIE',
      addresses: 'ADRESGEGEVENS',
      contacts: 'CONTACTPERSONEN',
      accountManager: 'RELATIEBEHEERDER',
      clientNumber: 'Klantnummer',
      email: 'E-mailadres',
      phone: 'Telefoon',
      vatNumber: 'BTW-nummer',
      sourceKvk: 'KvK',
      sourceImport: 'Import',
      sourceTeam: 'Team',
    },
    clientLog: {
      caption: (client) => `Bestanden en logboek van ${client}`,
      files: 'BESTANDEN',
      log: 'LOGBOEK',
      entry: {
        filed: (member) => `${member} deponeerde de jaarrekening bij de KvK`,
        taskCompleted: (member) => `${member} vinkte de aansluitcontrole loonheffingen af`,
        fileUploaded: (member) => `${member} uploadde de kolommenbalans`,
        vatFiled: (member) => `${member} diende de btw-aangifte van juni in`,
        contactAdded: (member) => `${member} voegde een contactpersoon toe`,
      },
      kb: 'kB',
    },
    clientRow: { caption: 'De maand van één klant op het maandbord' },
    dashboard: {
      title: 'Dashboard',
      caption: 'Dashboard-overzicht',
      myTasks: 'Mijn taken',
      hoursToday: 'Uren vandaag',
      leadTime: 'Doorlooptijd',
      ofPlanned: 'van 8:00 gepland',
      goodMorning: 'Goedemorgen',
    },
    employeeHours: {
      title: 'Urenregistratie',
      caption: 'Uren, verlof en overuren per medewerker',
      hoursTotal: 'UREN TOTAAL',
      sickHours: 'UREN ZIEK',
      leaveBalance: 'VERLOFSALDO',
      overtime: 'OVERUREN',
      fulltime: 'Fulltime contract',
      since: 'sinds 1 januari 2014',
    },
    excel: {
      title: 'Van Excel naar Offsoo',
      caption: 'Van Excel naar Offsoo',
      planning: 'Planning',
      monthPlanning: 'Maandplanning',
      fileName: 'Planning2026-DEFINITIEF(3).xlsx — Excel',
      lateNote: 'TE LAAT — wie pakt dit op???',
      copyNote: 'Q3 kopie??',
    },
    hoursDay: {
      title: 'Uren boeken',
      caption: 'Uren boeken op een dag',
      bookedThisDay: 'Geboekt op deze dag',
      addHours: 'Uren toevoegen',
      noHours: 'Geen uren op deze dag.',
      searchClient: 'Klant zoeken…',
      whatWasWorkedOn: 'Waar is aan gewerkt?',
      saveHours: 'Uren opslaan',
      saved: 'Opgeslagen ✓',
    },
    hoursMonth: {
      title: 'Urenregistratie',
      caption: 'De maand aan uren, en hoe één boeking erdoorheen telt',
    },
    hours: { title: 'Urenregistratie', addHours: 'Uren toevoegen', book: 'Boeken' },
    integrations: {
      title: 'Koppelingen',
      caption: 'Koppelingen: KvK, open API en MCP',
      kvkIntegration: 'KvK-integratie',
      kvkBody: 'Naam, adres en rechtsvorm rechtstreeks uit het handelsregister',
      openApi: 'Open API',
      apiBody: 'Klanten, planning, uren en taken lezen én schrijven — rechten per token',
      mcp: 'MCP-koppeling',
      mcpBody: 'Claude, ChatGPT en andere assistenten lezen mee',
      apiKey: 'API-sleutel',
      copy: 'Kopiëren',
      activeConnections: 'koppelingen actief',
      sampleQuestion: 'En wie is de relatiebeheerder?',
      screenTitle: 'Klantbeheer',
      active: 'ACTIEF',
      connecting: 'KOPPELEN…',
      connected: 'VERBONDEN',
      holdingQuestion: (client) => `Wat is de holdingstructuur van ${client}?`,
      holdingsAnswer: (count) => `${count === 3 ? 'Drie' : String(count)} holdings:`,
    },
    jaarplanning: {
      title: 'Jaarplanning',
      caption: 'Jaarplanning, boekjaar 2025 in uitvoering',
      booked: 'Geboekt ✓',
      chatReply: 'Ja, die rond ik vandaag af.',
      activityDone: (activity) => `${activity} afgerond`,
      chatQuestion: (activity, client) => `Kun jij de ${activity.toLowerCase()} van ${client} afronden?`,
    },
    leadTime: {
      title: 'Doorlooptijd',
      caption: 'Doorlooptijd-signalen',
      threshold: 'signaalgrens',
      longestOpen: 'Langst open',
    },
    mobile: {
      captionPlanning: 'Maandplanning van klanten in de Offsoo-app op de telefoon',
      captionHours: 'Uren boeken in de Offsoo-app op de telefoon',
      captionDossier: 'Klantdossiers in de Offsoo-app op de telefoon',
      noHoursToday: 'Geen uren op deze dag.',
      ownTasks: 'eigen taken',
      week: 'Week',
      companyDetails: 'BEDRIJFSGEGEVENS',
      contact: 'CONTACT',
      activities: 'WERKZAAMHEDEN',
      timeSpent: 'TIJDSBESTEDING',
      user: 'GEBRUIKER',
      date: 'DATUM',
      period: 'PERIODE',
      amount: 'BEDRAG',
      accountNumber: 'BANKREKENING',
      debtorNumber: 'DEBITEURNUMMER',
      vatNumber: 'BTW-NUMMER',
      kvk: 'KVK',
      email: 'E-MAILADRES',
      phone: 'TELEFOON',
      website: 'WEBSITE',
      projects: 'PROJECTEN',
      editEntry: 'Registratie bewerken',
      clientDetails: 'Klantdetails',
      chooseClient: 'Kies klant',
      allCount: (count) => `Alle ${count}`,
      step: (current, total) => `Stap ${current} / ${total}`,
      bookkeepingShort: 'FIN. ADM.',
      vatShort: 'OMZETB.',
    },
    monthPlanning: { title: 'Maandplanning', caption: 'Maandplanning-raster' },
    organogram: { title: 'Bedrijfsstructuur', caption: 'De bedrijfsstructuur rond één klant' },
    planningHours: {
      caption: 'Werkzaamheid afgerond',
      spentHours: 'Bestede uren',
      planned: 'Gepland',
      completed: 'Werkzaamheid afgerond',
      tickIsBooked: 'Afvinken is meteen geboekt',
      ticked: 'afgevinkt',
      newEntry: 'nieuwe vermelding',
      addComment: 'Voeg een opmerking toe…',
      send: 'Verzenden',
      sent: 'Verzonden ✓',
    },
    planningWall: {
      caption: 'De jaarplanning gefilterd op medewerker en deadline',
      searchUser: 'Zoek gebruiker…',
      searchMonth: 'Zoek maand…',
      searchTags: 'Zoek tags…',
      month: 'MAAND',
    },
    progress: { caption: 'Voortgang van het boekjaar, per maand', thisYear: 'dit jaar' },
    recurring: {
      title: 'Terugkerende taak inrichten',
      caption: 'Terugkerende taak inrichten',
      chooseFrequency: 'Kies frequentie',
      frequencies: ['Per maand', 'Per kwartaal', 'Per jaar'],
      quarterly: 'Per kwartaal',
      changePlanning: 'Planning wijzigen',
      fileReturn: (activity) => `${activity} indienen`,
    },
    reports: {
      title: 'Uurrapportage',
      caption: 'Urenrapport gefilterd op wat nog te factureren is',
      actions: 'Acties',
      export: 'Exporteren',
      changeColumns: 'Kolommen wijzigen',
      changeStatus: 'Status wijzigen',
      rows: 'regels',
      excel: 'Excel',
      exported: (rows) => `${rows} regels geëxporteerd naar Excel`,
    },
    migration: {
      monthly: 'maandelijks',
      quarterly: 'per kwartaal',
      invitesSent: 'Uitnodigingen verstuurd',
    },
  },
  content: {
    bookkeepingChecklist: [
      'Bankafschriften importeren',
      'Inkoopfacturen verwerken',
      'Verkoopfacturen verwerken',
      'Kasadministratie verwerken',
      'Memoriaalboekingen verwerken',
      'Openstaande posten controleren',
    ],
    bookkeepingChecklistShort: ['Bankafschriften', 'Inkoopfacturen', 'Verkoopfacturen'],
    annualAccountsChecklist: [
      'Concept jaarrekening opstellen',
      'Toelichting opstellen',
      // Formally the general meeting adopts the annual accounts; the firm prepares them and files
      // them at the Chamber of Commerce, which is the step that belongs on the firm's own checklist.
      'Jaarrekening deponeren (KvK)',
    ],
    reviewActivity: 'Kwaliteitsreview dossier',
    myTasks: ['Btw-aangifte Q2 voorbereiden', 'Jaarrekening reviewen', 'Suppletie OB nabellen'],
    entryNote: 'Bankmutaties en inkoopfacturen verwerkt',
    conceptNote: 'Concept jaarrekening opgesteld en aangesloten',
    hoursRemark: 'uren geboekt — dossier klaar voor controle',
    publicationDocs: 'Publicatiestukken KvK',
    vatCorrection: 'Suppletie omzetbelasting',
    internalMeeting: 'Intern overleg',
    yearEndClose: 'Jaarafsluiting administratie',
    reportStatus: {
      'te-factureren': 'Te factureren',
      gefactureerd: 'Gefactureerd',
      'niet-facturabel': 'Niet facturabel',
    },
    awaitingClient: 'Ter goedkeuring klant',
    awaitingClientReply: 'Wacht op klant',
    awaitingDocuments: 'Wacht op stukken',
    addressTag: { ZAKELIJK: 'ZAKELIJK', POST: 'POST' },
  },
  chat: {
    and: ' en ',
    comma: ', ',
    yearWork: {
      question: 'Welke jaarrekeningen lopen nog?',
      followUp: 'En wat ligt het langst stil?',
      answerLead: 'hebben hun jaarrekening nog niet afgerond.',
      ofWhichOne: 'daarvan is nog niet gestart:',
      ofWhichMany: 'daarvan zijn nog niet gestart:',
      openFor: 'al',
      overThreshold: (days) => `${days} dagen over de signaalgrens.`,
    },
    planning: {
      question: 'Welke btw-aangiftes zijn nog niet gestart?',
      followUp: 'En wie heeft er deze week nog ruimte?',
      allThreeWithDeadline: 'alle drie met deadline',
      allWithDeadline: 'alle met deadline',
      isAt: 'zit op',
      enoughRoom: '— genoeg ruimte om aangiftes over te nemen.',
    },
    hours: {
      question: 'Hoeveel uur schreef het team vorige maand?',
      followUp: 'Welke klanten zitten boven hun budget?',
      lastMonth: (hours, month, billable, activity) =>
        `${hours} uur in ${month}, waarvan ${billable} facturabel — het meeste op ${activity}.`,
      overBudget: (count, list) => `${count === 2 ? 'Twee' : String(count)}: ${list}.`,
    },
    leadTime: (days, client) => `${client} staat ${days} dagen langer stil dan de signaalgrens.`,
  },
}
